<div class="collapse__container__header" [ngClass]="isCollapsed ? 'collapse__container__header--collapsed' : ''" (click)="toggleCollapse()">
    <h4>{{headerText}}</h4>
    <i class="fa-solid fa-caret-down collapse__container__header__toggle" [ngClass]="isCollapsed ? '' : 'collapse__container__header__toggle--reversed'"></i>
</div>
<div #collapseContentContainer class="collapse__container__content" [ngClass]="isCollapsed ? 'collapse__container__content--collapsed' : ''">
    <ng-content></ng-content>
</div>